// Restaurant data for Zum Goldenen Döner & Pizza Haus
import logo from "./assets/logo.png";

export const restaurant = {
  name: "Zum Goldenen Döner",
  subName: "& Pizza Haus",
  tagline: "Frisch vom Drehspieß & ofenfrische Pizza",
  address: "Marktstraße 78, 47798 Krefeld",
  phone: "02151 6450877",
  phoneHref: "tel:+4921516450877",
  mapsQuery: "Zum Goldenen Döner & Pizza Haus, Marktstraße 78, 47798 Krefeld",
  ratings: {
    google: { score: "4.1", count: "260" },
    lieferando: { score: "4.7", count: "411" },
  },
  hours: [
    { day: "Montag", time: "10:00 – 22:00" },
    { day: "Dienstag", time: "10:00 – 22:00" },
    { day: "Mittwoch", time: "10:00 – 22:00" },
    { day: "Donnerstag", time: "10:00 – 22:00" },
    { day: "Freitag", time: "10:00 – 22:00" },
    { day: "Samstag", time: "11:00 – 22:00" },
    { day: "Sonntag & Feiertage", time: "11:00 – 22:00" },
  ],
  deliveryHours: [
    { day: "Montag – Freitag", time: "16:00 – 22:00" },
    { day: "Sa, So & Feiertage", time: "11:30 – 22:00" },
  ],
  delivery: "Lieferung: Mindestbestellwert 20 € · Lieferradius bis 10 km",
};

export const images = {
  logo,
  hero: "https://images.pexels.com/photos/29626982/pexels-photo-29626982.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  doner: "https://images.pexels.com/photos/29306504/pexels-photo-29306504.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  durum: "https://images.unsplash.com/photo-1773620494884-940e0db95e46?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  pizza: "https://images.unsplash.com/photo-1571997478779-2adcbbe9ab2f?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  donerHeld: "https://images.unsplash.com/photo-1699728088614-7d1d4277414b?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  interior: "https://images.unsplash.com/photo-1705743244501-a88b02c524fb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// Pizza has its own structure (3 sizes)
export const pizza = {
  title: "Pizza",
  note: "S 24 · M 30 · XL 40 cm",
  desc: "Mit Tomatensauce, Sauce Hollandaise, BBQ- oder Curry-Sauce & Goudakäse.",
  items: [
    { num: "35", name: "Margherita", desc: "Tomaten & Käse", s: "4,50", m: "7,95", xl: "12,95" },
    { num: "36", name: "Salami", desc: "Putensalami", s: "6,50", m: "8,95", xl: "16,95" },
    { num: "37", name: "Prosciutto", desc: "Putenschinken", s: "6,50", m: "8,95", xl: "16,95" },
    { num: "38", name: "Sucuk", desc: "Knoblauchwurst", s: "6,95", m: "9,50", xl: "17,95" },
    { num: "39", name: "Tonno", desc: "Thunfisch", s: "6,95", m: "9,50", xl: "17,95" },
    { num: "40", name: "Brokkoli", desc: "Brokkoli", s: "5,95", m: "8,95", xl: "16,95" },
    { num: "41", name: "Funghi", desc: "Champignons", s: "5,95", m: "8,95", xl: "16,95" },
    { num: "42", name: "Spinaci", desc: "Spinat & Knoblauch", s: "5,95", m: "8,95", xl: "16,95" },
    { num: "43", name: "Drehspieß Hollandaise", desc: "Sauce Hollandaise & Knoblauch", s: "6,95", m: "10,95", xl: "21,00" },
    { num: "44", name: "Drehspieß Livorno", desc: "Tomaten, Jalapeños & Zwiebeln", s: "6,95", m: "10,95", xl: "21,00" },
    { num: "45", name: "Chicken Hollandaise", desc: "Hähnchenbrust, Mais, Paprika & Brokkoli", s: "6,95", m: "10,95", xl: "21,00" },
    { num: "46", name: "Chicken BBQ", desc: "Hähnchenbrust, Mais, Zwiebeln & Tomaten", s: "6,95", m: "10,95", xl: "21,00" },
    { num: "47", name: "Livorno", desc: "Salami & Jalapeños", s: "6,50", m: "9,50", xl: "18,00" },
    { num: "48", name: "Quattro Stagioni", desc: "Paprika, Thunfisch, Salami, Schinken & Champignons", s: "6,95", m: "10,95", xl: "21,00" },
    { num: "49", name: "Alanya", desc: "Knoblauchwurst, Mais, Champignons, Zwiebeln & Tomaten", s: "6,95", m: "10,95", xl: "19,95" },
    { num: "50", name: "Atina", desc: "Schafskäse, Oliven, Spinat & Knoblauch", s: "6,95", m: "10,95", xl: "19,95" },
    { num: "51", name: "Capricciosa", desc: "Putenschinken & Champignons", s: "6,50", m: "9,50", xl: "18,00" },
    { num: "52", name: "Diavolo", desc: "Paprika, Zwiebeln & Jalapeños", s: "6,50", m: "9,50", xl: "18,00" },
    { num: "53", name: "Vegetarisch", desc: "Brokkoli, Zwiebeln & Champignons", s: "6,50", m: "9,50", xl: "18,00" },
    { num: "54", name: "Hawaii", desc: "Putenschinken & Ananas", s: "6,50", m: "9,50", xl: "18,00" },
    { num: "57", name: "Mozzarella", desc: "Tomaten & Mozzarella", s: "6,50", m: "9,50", xl: "18,00" },
    { num: "58", name: "Krabben", desc: "Krabben & Knoblauch", s: "6,95", m: "10,95", xl: "21,00" },
    { num: "59", name: "Frutti di Mare", desc: "Meeresfrüchte & Knoblauch", s: "6,95", m: "10,95", xl: "21,00" },
  ],
  calzoni: [
    { num: "55", name: "Calzone Hollandaise", desc: "Drehspieß, Brokkoli & Zwiebeln · 30 cm", price: "9,95" },
    { num: "56", name: "Calzone Quattro", desc: "Thunfisch, Putenschinken & Champignons · 30 cm", price: "9,95" },
  ],
  blech: {
    title: "Blech-Pizza (60 × 40 cm)",
    base: "Margherita 18,00 €",
    plus10: "+10 € je Belag: Döner, Knoblauchwurst, Hähnchenbrust, Thunfisch, Schinken, Salami, Krabben, Meeresfrüchte",
    plus5: "+5 € je Belag: Artischocken, Spinat, Brokkoli, Paprika, Peperoni, Mais, Champignons, Tomaten, Zwiebeln, Ei, Oliven",
  },
};

export const menu = [
  {
    id: "drehspiess",
    title: "Drehspieß & Lahmacun",
    note: "Bestseller",
    desc: "Mit Krautsalat, grünem Salat, Rotkohl, Zwiebeln, Tomaten, Peperoni, Käse & Tzatziki. Kalb oder Hähnchen.",
    items: [
      { num: "01", name: "Drehspieß Tasche", desc: "Kalb oder Hähnchen", price: "6,95" },
      { num: "02", name: "Drehspieß Tasche Groß", desc: "Kalb oder Hähnchen", price: "11,95" },
      { num: "03", name: "Drehspieß Dürüm", desc: "Kalb oder Hähnchen", price: "7,50" },
      { num: "04", name: "Drehspieß Teller Groß", desc: "Mit Pommes oder Reis und Salat", price: "11,95" },
      { num: "05", name: "Drehspieß Teller", desc: "Mit Pommes oder Reis", price: "9,50" },
      { num: "06", name: "Drehspieß Teller mit Salat", desc: "Frischer Salat & Sauce", price: "9,50" },
      { num: "07", name: "Drehspieß Portion", desc: "gr. 8,50 · XXL 12,00", price: "8,50" },
      { num: "08", name: "Lahmacun", desc: "Mit Zitrone & Petersilie", price: "3,50" },
      { num: "09", name: "Lahmacun mit Salat & Sauce", desc: "Türkische Pizza", price: "6,00" },
      { num: "10", name: "Lahmacun Spezial", desc: "Mit Drehspieß, Salat & Sauce", price: "7,50" },
      { num: "11", name: "Drehspieß Box", desc: "Mit Pommes oder Reis · kl. 5,50 · gr.", price: "6,50" },
    ],
  },
  {
    id: "imbiss",
    title: "Imbiss-Gerichte",
    items: [
      { num: "20", name: "Chicken Nuggets", desc: "6 Stk. 4,00 · 9 Stk., mit Süß-Sauer-/BBQ-Sauce", price: "7,00" },
      { num: "21", name: "Chicken Wings", desc: "6 Stk. 5,50 · 9 Stk., mit Süß-Sauer-/BBQ-Sauce", price: "8,50" },
      { num: "22", name: "Fleischrolle", desc: "Knusprig", price: "3,00" },
      { num: "23", name: "Fleischrolle Spezial", desc: "Mit Zwiebeln, Ketchup & Mayonnaise", price: "5,00" },
      { num: "24", name: "Mozzarella Sticks", desc: "6 Stück", price: "5,50" },
      { num: "25", name: "Chili Cheese", desc: "6 Stück", price: "5,50" },
      { num: "26", name: "Portion Reis", desc: "Beilage", price: "3,50" },
      { num: "27", name: "Pommes Spezial", desc: "Mit Zwiebeln, Ketchup & Mayonnaise", price: "5,50" },
      { num: "28", name: "Pommes Frites", desc: "kl. 2,95 · gr.", price: "3,95" },
      { num: "29", name: "Chili Cheese Pommes", desc: "Herzhaft", price: "6,00" },
    ],
  },
  {
    id: "burger",
    title: "Hamburger",
    desc: "Mit Joppiesauce, Salat, Tomaten & Zwiebeln.",
    items: [
      { num: "30", name: "Hamburger", desc: "100 g · Doppelt 200 g 8,50", price: "6,00" },
      { num: "31", name: "Cheeseburger", desc: "100 g · Doppelt 200 g 9,50", price: "7,00" },
      { num: "32", name: "Chili-Cheeseburger", desc: "100 g · Doppelt 200 g 11,00", price: "8,50" },
      { num: "33", name: "Chickenburger", desc: "100 g · Doppelt 200 g 8,50", price: "6,00" },
      { num: "34", name: "Hamburger Menü", desc: "Mit Pommes & Getränk 0,33 l", price: "10,00" },
    ],
  },
  {
    id: "brotpide",
    title: "Pizzabrötchen & Pide",
    desc: "Pizzabrötchen als Portion (8–10 Stück).",
    items: [
      { num: "61", name: "Gefüllte Pizzabrötchen mit Käse", desc: "8–10 Stück", price: "5,00" },
      { num: "62", name: "Gefüllte Pizzabrötchen Spezial", desc: "Käse & eine Zutat nach Wahl", price: "6,50" },
      { num: "70", name: "Pide mit Käse", desc: "Ofenfrisch", price: "7,00" },
      { num: "71", name: "Pide mit Drehspieß", desc: "Ofenfrisch", price: "8,00" },
      { num: "72", name: "Pide mit Spinat", desc: "Ofenfrisch", price: "7,50" },
      { num: "73", name: "Pide mit Knoblauchwurst", desc: "Ofenfrisch", price: "8,00" },
    ],
  },
  {
    id: "schnitzel",
    title: "Schnitzel & Überbackenes",
    desc: "Schnitzel 200 g, mit Salat, Pommes oder Reis.",
    items: [
      { num: "80", name: "Schnitzel Wiener Art", desc: "Mit Zitrone", price: "8,95" },
      { num: "81", name: "Jägerschnitzel", desc: "Mit Beilage nach Wahl", price: "9,95" },
      { num: "82", name: "Schnitzel Hollandaise Brokkoli", desc: "Überbacken", price: "9,95" },
      { num: "83", name: "Schnitzel Paprika", desc: "Mit Beilage nach Wahl", price: "9,95" },
      { num: "90", name: "Drehspieß Hollandaise", desc: "Zwiebeln, Brokkoli & Käse überbacken", price: "9,95" },
      { num: "91", name: "Drehspieß Tomato", desc: "Tomaten, Jalapeños & Käse überbacken", price: "9,95" },
      { num: "92", name: "Schnitzel überbacken", desc: "Mais, Paprika, Hollandaise & Käse", price: "9,95" },
      { num: "93", name: "Schnitzel mit Käse überbacken", desc: "Klassisch", price: "8,50" },
    ],
  },
  {
    id: "salate",
    title: "Salate & Suppen",
    desc: "Salate mit Tomaten, Gurken, Dressing & 4 Pizzabrötchen.",
    items: [
      { num: "100", name: "Capricciosa Salat", desc: "Thunfisch, Schinken, Ei & Gouda", price: "8,00" },
      { num: "101", name: "Chicken Salat", desc: "Chicken & Paprika", price: "8,00" },
      { num: "102", name: "Tonno Salat", desc: "Thunfisch & rote Zwiebeln", price: "7,00" },
      { num: "103", name: "Basissalat", desc: "Tomaten, Gurken, Möhren & Mais", price: "6,50" },
      { num: "104", name: "Bauernsalat (Çoban)", desc: "Tomaten, Gurken & Zwiebeln", price: "6,00" },
      { num: "110", name: "Mercimek", desc: "Linsensuppe mit Brot & Zitrone", price: "5,50" },
      { num: "111", name: "Tavuk", desc: "Hühnersuppe mit Brot & Zitrone", price: "6,00" },
    ],
  },
  {
    id: "vegetarisch",
    title: "Vegetarisch",
    desc: "Falafel mit Krautsalat, Salat, Rotkohl, Zwiebeln, Tomaten & Sauce.",
    items: [
      { num: "120", name: "Falafel Tasche", desc: "Mit Salat & Sauce", price: "6,00" },
      { num: "121", name: "Falafel Dürüm", desc: "Im Fladenbrot", price: "7,00" },
      { num: "122", name: "Falafel Teller", desc: "Mit Pommes oder Reis & Sauce", price: "11,95" },
      { num: "123", name: "Falafel Hamburger", desc: "Mit Salat & Sauce", price: "6,00" },
      { num: "124", name: "Falafel Cheeseburger", desc: "Mit Käse", price: "7,00" },
      { num: "125", name: "Vegetarische Tasche", desc: "Mit Salat & Sauce", price: "5,50" },
      { num: "126", name: "Falafel Box", desc: "kl. 5,50 · gr.", price: "6,50" },
    ],
  },
  {
    id: "getraenke",
    title: "Getränke",
    items: [
      { name: "Cola / Fanta / Sprite / Uludağ 0,33 l", desc: "Auch Zero & Light", price: "2,00" },
      { name: "Cola / Fanta / Sprite 1,0 l", desc: "Familienflasche", price: "3,00" },
      { name: "Fuze Tea", desc: "Eistee", price: "2,00" },
      { name: "Ayran 0,25 l", desc: "Erfrischend", price: "1,50" },
      { name: "Durstlöscher 0,5 l", desc: "Verschiedene Sorten", price: "1,50" },
      { name: "Red Bull 0,25 l", desc: "Energy", price: "2,50" },
      { name: "Wasser still / Sprudel 0,5 l", desc: "Hayat", price: "1,50" },
    ],
  },
  {
    id: "extras",
    title: "Backwaren & Extras",
    items: [
      { num: "130", name: "Baklava Pistazien", desc: "Portion 4 Stück", price: "5,00" },
      { num: "131", name: "Baklava Walnuss", desc: "Portion 4 Stück", price: "3,00" },
      { num: "134", name: "Börek", desc: "Herzhaft gefüllt", price: "1,30" },
      { num: "133", name: "Simit", desc: "Sesamkringel", price: "1,20" },
      { num: "140", name: "Tzatziki / Oliven / Schafskäse", desc: "Pro Portion", price: "2,00" },
      { num: "141", name: "Hollandaise / Juppy / Scharfe Sauce", desc: "Pro Portion", price: "1,50" },
      { num: "142", name: "Ketchup / Salatmayo / Süß-Sauer", desc: "Pro Portion", price: "0,60" },
    ],
  },
];

export const reviews = [
  { id: "rev-1", name: "Abdulkader A", source: "Google", score: 5, text: "Schöner Ort, freundliche Bedienung und richtig leckerer Döner. Immer wieder gerne!" },
  { id: "rev-2", name: "Mehmet K.", source: "Lieferando", score: 5, text: "Pünktliche Lieferung und die Pizza war noch schön heiß. Der Teig ist mega!" },
  { id: "rev-3", name: "Sabine W.", source: "Google", score: 4, text: "Guter Döner zu fairem Preis. Die Portionen sind ordentlich, komme aus der Nachbarschaft." },
  { id: "rev-4", name: "Ali R.", source: "Lieferando", score: 5, text: "Bester Dürüm in Krefeld. Fleisch frisch vom Spieß, genau wie es sein soll." },
  { id: "rev-5", name: "Julia M.", source: "Google", score: 5, text: "Die Döner Pizza ist ein Traum. Personal ist super nett und schnell." },
  { id: "rev-6", name: "Kevin B.", source: "Lieferando", score: 4, text: "Falafel und Lahmacun top. Lieferung war zügig und alles gut verpackt." },
];

export const highlights = [
  { title: "Frisch vom Drehspieß", text: "Kalb- & Hähnchenfleisch täglich frisch zubereitet." },
  { title: "Ofenfrische Pizza", text: "Handgemachter Teig, in drei Größen (24/30/40 cm)." },
  { title: "Lieferung & Abholung", text: "Bequem nach Hause oder direkt bei uns abholen." },
];
